import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { useAuth } from "../../auth";

export const Route = createFileRoute("/__auth/logout")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const navigate = Route.useNavigate();
  const auth = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);

    const performLogout = async () => {
      await auth.logout();
      await router.invalidate();
      await navigate({ to: "/login", replace: true });
    };

    performLogout();
  }, [auth, router, navigate, isLoggingOut]);

  return (
    <Box sx={{ width: "100%", marginY: "25%" }}>
      <Stack alignItems="center" justifyContent="center" spacing={2}>
        <CircularProgress />
        <Typography>Deslogando...</Typography>
      </Stack>
    </Box>
  );
}
